import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Spline, { POINT_TYPE } from '../spline.js';
import InputConnector from '../inputConnector.js';

export default class NodeCreateLine extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.BOOLEAN, 'is_2D', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'is_closed', false);
		this.addInput(PARAM_TYPE.INTEGER, 'num_points', 2, { minValue: 2, maxValue: 10 });

		this.onInputChangedSubclass('num_points');

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{
		return 'createLine';
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'num_points' || strInputName == 'is_2D';
	}

	onInputChangedSubclass(strInputName)
	{
		if(strInputName !== 'num_points' && strInputName !== 'is_2D')
			return;

		const bIs2D = this.getLastInputResult('is_2D');

		// Otherwise, update our connectors:
		let pInput;
		let pNewInputs = [this.getInput('num_points'), this.getInput('is_2D'), this.getInput('is_closed')];
		for(let idx = 0; idx < this.getLastInputResult('num_points'); idx++)
		{
			pInput = new InputConnector(PARAM_TYPE.FLOAT, `point${idx + 1}_x`, null, 0, { minValue: -2, maxValue: 2, units: PARAM_UNITS.METERS });
			pNewInputs.push(pInput);

			pInput = new InputConnector(PARAM_TYPE.FLOAT, `point${idx + 1}_y`, null, 0, { minValue: -2, maxValue: 2, units: PARAM_UNITS.METERS });
			pNewInputs.push(pInput);

			if(!bIs2D)
			{
				pInput = new InputConnector(PARAM_TYPE.FLOAT, `point${idx + 1}_z`, null, 0, { minValue: -2, maxValue: 2, units: PARAM_UNITS.METERS });
				pNewInputs.push(pInput);
			}
		}
		this.updateInputsOutputs(pNewInputs);
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		const bIs2D = inputValues['is_2D'];

		let pCurrPoint;
		let points = [];
		for(let iPoint = 0; iPoint < inputValues['num_points']; iPoint++)
		{
			pCurrPoint = { 
				x: inputValues[`point${iPoint + 1}_x`],
				y: inputValues[`point${iPoint + 1}_y`]
			};

			if(!bIs2D)
				pCurrPoint['z'] = inputValues[`point${iPoint + 1}_z`];

			points.push({ point: pCurrPoint, type: POINT_TYPE.LINEAR });
		}

		let pSpline = new Spline({ points: points, isClosed: inputValues['is_closed'] });
		return pSpline.saveToObject();
	}
}